import { Button } from "antd";
import { configConsumerProps } from "antd/lib/config-provider";
import React, { useState } from "react";
import { Alert, Space, Checkbox, Form, Input } from "antd";
import { useHistory } from "react-router-dom";
import axios from "../../services/axios";
import { Modal, ModalHeader } from "reactstrap";

const ChangePassword = ({ component,openModal,closeModal }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [status, setStatus] = useState();
  const [response, setResponse] = useState("");

  const handleCurrentPassword = (e) => {
    console.log("cpdd", e.target.value);
    setStatus("");
    setCurrentPassword(e.target.value);
  };

  const handleNewPassword = (e) => {
    setStatus("");
    setNewPassword(e.target.value);
    const isNonWhiteSpace = /^\S*$/;
    let value = e.target.value;
    if (!isNonWhiteSpace.test(value)) {
      setNewPasswordError("Password must not contain Whitespaces.");
    }

    const isContainsUppercase = /^(?=.*[A-Z]).*$/;
    if (!isContainsUppercase.test(value)) {
      setNewPasswordError(
        "Password must have at least one Uppercase Character."
      );
    }

    const isContainsLowercase = /^(?=.*[a-z]).*$/;
    if (!isContainsLowercase.test(value)) {
      setNewPasswordError(
        "Password must have at least one Lowercase Character."
      );
    }

    const isContainsNumber = /^(?=.*[0-9]).*$/;
    if (!isContainsNumber.test(value)) {
      setNewPasswordError("Password must contain at least one Digit.");
    }

    const isContainsSymbol =
      /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).*$/;
    if (!isContainsSymbol.test(value)) {
      setNewPasswordError("Password must contain at least one Special Symbol.");
    }

    const isValidLength = /^.{6,12}$/;
    if (value.length < 6) {
      setNewPasswordError("Password must be 6-12 Characters Long.");
    }
    if (
      value.length >= 6 &&
      isContainsSymbol.test(value) &&
      isContainsNumber.test(value) &&
      isContainsLowercase.test(value) &&
      isContainsUppercase.test(value) &&
      isNonWhiteSpace.test(value)
    ) {
      setNewPasswordError("");
    }
  };

  const handleConfirmPasswor = (e) => {
    setStatus("");
    setConfirmPassword(e.target.value);
    const isNonWhiteSpace = /^\S*$/;
    let value = e.target.value;
    if (!isNonWhiteSpace.test(value)) {
      setConfirmPasswordError("Password must not contain Whitespaces.");
    }

    const isContainsUppercase = /^(?=.*[A-Z]).*$/;
    if (!isContainsUppercase.test(value)) {
      setConfirmPasswordError(
        "Password must have at least one Uppercase Character."
      );
    }

    const isContainsLowercase = /^(?=.*[a-z]).*$/;
    if (!isContainsLowercase.test(value)) {
      setConfirmPasswordError(
        "Password must have at least one Lowercase Character."
      );
    }

    const isContainsNumber = /^(?=.*[0-9]).*$/;
    if (!isContainsNumber.test(value)) {
      setConfirmPasswordError("Password must contain at least one Digit.");
    }

    const isContainsSymbol =
      /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).*$/;
    if (!isContainsSymbol.test(value)) {
      setConfirmPasswordError(
        "Password must contain at least one Special Symbol."
      );
    }

    const isValidLength = /^.{6,12}$/;
    if (value.length < 6) {
      setConfirmPasswordError("Password must be 6-12 Characters Long.");
    }
    if (
      value.length >= 6 &&
      isContainsSymbol.test(value) &&
      isContainsNumber.test(value) &&
      isContainsLowercase.test(value) &&
      isContainsUppercase.test(value) &&
      isNonWhiteSpace.test(value)
    ) {
      setConfirmPasswordError("");
    }
  };
  const showModal = () => {
    setNewPassword("");
    setConfirmPassword("");
    closeModal(true);
  };

  function changeConsultantPassword() {
    axios
      .put(
        `/registerConsultant/ResetPassword/${localStorage.getItem("user.id")}`,
        {
          oldPassword: currentPassword,
          newPassword: newPassword,
          confirmNewPassword: confirmPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res) => {
        console.log("logs", res.data.message);
        //Password Updated Successfully
        setStatus(true);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err.response.data.message);
        setResponse(err.response.data.message);
        setStatus(false);
        setLoading(false);
      });
  }

  const handleOk = () => {
    setLoading(true);
    // setTimeout(() => {
    //   setLoading(false);
    //   closeModal(false);
    // }, 3000);
    if (
      currentPassword &&
      newPassword &&
      confirmPassword &&
      confirmPasswordError === "" &&
      newPasswordError === ""
    ) {
      if (component === "consultant") {
        changeConsultantPassword();
      } else {
        axios
          .put(
            `/${component === "career" ? "candidate" : "User"}/changepassword/${
              component === "career"
                ? localStorage.getItem("candidate.id")
                : localStorage.getItem("user.id")
            }`,
            {
              oldPassword: currentPassword,
              newPassword: newPassword,
              confirmNewPassword: confirmPassword,
            },
            {
              headers: {
                Authorization: `Bearer ${
                  component === "career"
                    ? localStorage.getItem("candidate.token")
                    : localStorage.getItem("user.token")
                }`,
              },
            }
          )
          .then((res) => {
            console.log("logs", res.data.message);
            //Password Updated Successfully
            setStatus(true);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err.response.data.message);
            setResponse(err.response.data.message);
            setStatus(false);
            setLoading(false);
          });
      }
    } else {
      setStatus("empty Fields");
      setLoading(false);
    }
  };
  const handleCancel = () => {
    closeModal(false);
    // console.log("cancel");
    if (status === true) {
      localStorage.clear();
      if (component === "career") {
        history.push("/careers");
      }
      else if(component === "consultant"){
        history.push("/consultant");
      }
       else {
        history.push("/");
      }
    }
  };

  const onFinish = (values) => {
    console.log("Success:", values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const logout = () => {
    localStorage.clear();
    if (component === "career") {
      history.push("/careers");
    } else {
      history.push("/");
    }
  };

  return (
    <>
      <Modal
        // width="600px"
        isOpen={openModal}
        // onOk={handleOk}
        toggle={handleCancel}
        // footer={[
        //   // <Button key="back" onClick={handleCancel}>
        //   //   Return
        //   // </Button>,
        //   <Button
        //     key="submit"
        //     type="primary"
        //     loading={loading}
        //     onClick={handleOk}
        //     disabled={
        //       status === true ||
        //       newPassword !== confirmPassword ||
        //       newPasswordError !== "" ||
        //       confirmPasswordError !== ""
        //         ? true
        //         : false
        //     }
        //   >
        //     Submit
        //   </Button>,
        // ]}
      >
        <ModalHeader toggle={handleCancel}>Change Password</ModalHeader>
        <div className="p-4">
          <div style={{ marginBottom: "20px" }}>
            {status === true && (
              <Alert
                message="Password Updated Successfully! "
                type="success"
                showIcon
                action={
                  <Button onClick={logout} size="small" type="text">
                    Please Click Here to re-Login
                  </Button>
                }
                //  closable
              />
            )}
            {status === false && (
              <Alert
                message="OOPs! Currrent Password didn't matched"
                showIcon
                // description="Error Description Error Description Error Description Error Description"
                type="error"
                closable
              />
            )}
            {status === "empty Fields" && (
              <Alert
                message="OOPs! All Fields are mandatory"
                showIcon
                // description="Error Description Error Description Error Description Error Description"
                type="error"
                closable
              />
            )}
          </div>
          <Form
            name="basic"
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 16,
            }}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label="Current Password"
              name="current password"
              value={currentPassword}
              onChange={handleCurrentPassword}
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              label="New Password"
              name="new password"
              value={newPassword}
              onChange={handleNewPassword}
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
            >
              <Input.Password />
              {newPasswordError && (
                <div className="text-danger" style={{ marginTop: 5 + "px" }}>
                  {newPasswordError}
                </div>
              )}
              {newPasswordError === "" && newPassword.length >= 6 && (
                <div className="text-success" style={{ marginTop: 5 + "px" }}>
                  Great!
                </div>
              )}
            </Form.Item>
            <Form.Item
              label="Confirm Password"
              name="confirm password"
              value={confirmPassword}
              onChange={handleConfirmPasswor}
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
            >
              <Input.Password />
              {confirmPasswordError && (
                <div className="text-danger" style={{ marginTop: 5 + "px" }}>
                  {confirmPasswordError}
                </div>
              )}
              {confirmPasswordError === "" && confirmPassword.length >= 6 && (
                <>
                  {newPassword === confirmPassword ? (
                    <div
                      className="text-success"
                      style={{ marginTop: 5 + "px" }}
                    >
                      Great!
                    </div>
                  ) : (
                    <div
                      className="text-danger"
                      style={{ marginTop: 5 + "px" }}
                    >
                      Password didn't matched
                    </div>
                  )}
                </>
              )}
            </Form.Item>
            <Button
              key="submit"
              type="primary"
              loading={loading}
              onClick={handleOk}
              disabled={
                status === true ||
                newPassword !== confirmPassword ||
                newPasswordError !== "" ||
                confirmPasswordError !== ""
                  ? true
                  : false
              }
            >
              Submit
            </Button>
          </Form>
        </div>
      </Modal>
    </>
  );
};
export default ChangePassword;
